import {createSlice} from '@reduxjs/toolkit';

const initialInvoicesState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  totalAmount: 0,
  error: null,
};
export const callTypes = {
  list: 'list',
  action: 'action'
};

export const invoicesSlice = createSlice({
  name: 'invoices',
  initialState: initialInvoicesState,
  reducers: {
    invoicesFetched: (state, action) => {
      const {totalCount, pageCount, entities, totalAmount} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.totalAmount = totalAmount;
    },
    invoicesAppended: (state, action) => {
      const {totalCount, pageCount, entities, totalAmount} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.totalAmount = totalAmount;
    },
    sendReminder: (state, action) => {
      const {invoiceID, reminderCount, lastReminderDate} = action.payload;
      const mappedArray = state.entities.map(item => item._id);
      const index = mappedArray.indexOf(invoiceID);
      if (Boolean(state.entities)) {
        state.entities[index]._id = invoiceID;
        state.entities[index].reminderCount = reminderCount;
        state.entities[index].lastReminderDate = lastReminderDate;
      }
    },
    addReceiptToInvoice: (state, action) => {
      const {invoiceID, receiptID} = action.payload;
      const mappedArray = state.entities.map(item => item._id);
      const index = mappedArray.indexOf(invoiceID);
      if (Boolean(state.entities)) {
        state.entities[index]._id = invoiceID;
        state.entities[index].receipts.push(receiptID);
        state.entities[index].statusName = 'סגורה';
        state.entities[index].status = 2;
      }
    },
    reopenInvoice: (state, action) => {
      const {invoiceID} = action.payload;
      const mappedArray = state.entities.map(item => item._id);
      const index = mappedArray.indexOf(invoiceID);
      if (Boolean(state.entities[index])) {
        state.entities[index].statusName = 'פתוחה';
        state.entities[index].status = 1;
        state.entities[index].receipts = [];
      }
    },
    cancelInvoice: (state, action) => {
      const {invoiceID} = action.payload;
      const mappedArray = state.entities.map(item => item._id);
      const index = mappedArray.indexOf(invoiceID);
      if (Boolean(state.entities[index])) {
        state.entities[index].statusName = 'סגורה';
        state.entities[index].status = 2;
      }
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoicesError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
